<div class="row">
  <div class="col eip-pl-xs-10">
      <mat-button-toggle-group aria-label="Font Style" class="eip-ml-xs-0 eip-ml-15 eip-mb-xs-10" [(ngModel)]="buttonToggle" (change)="changeButtonToggle($event)">
          <mat-button-toggle value="ELEMENT">Element</mat-button-toggle>
          <mat-button-toggle value="STATICELEMENT">Static Element</mat-button-toggle>
      </mat-button-toggle-group>
  </div>
</div>
<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }" *ngIf="isElement">
  <kendo-grid [kendoGridBinding]="elementLinkList" [scrollable]="true" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="15" class="auto-complete-equal" [pageable]="true" [height]="540">
      <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex">
              <div class="flex-grow-1 mat-panel-headerbar"></div>
              <div class="pagination-container" style="width:25%;font-weight: bold;display: flex;float: right;"><span style="width:35%;" class="eip-mr-15 d-none d-md-block">Business Group :</span>
                  <div style="width:95%;">
                      <EIPAutoComplete ShowTextValueField='N' TextField="group_Name" ValueField="group_Id" floatLabelOption="never" [dataSource]='elementLinkService.businessGroupList' setId="ddMrlBusGrpId" [defaultValue]='elementLinkService.selectedBusinessGrpId' (valueChange)='changeBusinessGroup($event)' [IsCascading]='true'>
                      </EIPAutoComplete>
                  </div>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                  </kendo-pager-page-sizes>
                  <span>Items</span>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                  <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                      <div class="icon-wrap" (click)="toggleFilter()">
                          <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                          <span class="list-icon-name">Filter</span>
                      </div>
                      <div class="icon-wrap" (click)="toggleFullscreen()">
                          <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                      </div>
                  </div>
                  <div class="divider-container d-none d-md-block"><span></span></div>
                  <i class="fa fa fa-plus-circle eip-pl-xs-0" (click)="addEditElementLink(null,true)" aria-hidden="true" id="" matTooltip="Add Element"></i>
              </div>
          </div>
      </ng-template>
      <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{rowIndex+1}}
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Module" class="text-left" field="moduleDescription" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.moduleDescription}}" eipTooltipPosition="auto">{{dataItem.moduleDescription}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Element" class="text-left" field="elementDescription" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.elementDescription}}" eipTooltipPosition="auto">{{dataItem.elementDescription}}</span>
          </ng-template>
      </kendo-grid-column>
      <!-- <kendo-grid-column title="Project Element Description" class="text-left" field="projectElementDescription" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.projectElementDescription}}" eipTooltipPosition="auto">{{dataItem.projectElementDescription}}</span>
          </ng-template>
      </kendo-grid-column> -->
      <kendo-grid-column title="Has Dependency" class="text-left" [filterable]="false" field="hasDependency" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.hasDependency" [disabled]="true" [size]="small"></kendo-switch>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Dependent On Element" class="text-left" field="dependentElementDescription" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.dependentElementDescription}}" eipTooltipPosition="auto">{{dataItem.dependentElementDescription}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Mandatory" class="text-left" [filterable]="false" field="isMandatory" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isMandatory" [disabled]="true" [size]="smaller"></kendo-switch>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Default Select" class="text-left" [filterable]="false" field="isDefaultSelect" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isDefaultSelect" [disabled]="true" [size]="smaller"></kendo-switch>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Is Active" class="text-left" [filterable]="false" field="isDefaultSelect" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isActive" [disabled]="true" [size]="smaller"></kendo-switch>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Created By" field="created_By" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">{{dataItem.created_By}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Created On" field="created_On" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.created_On | date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Modified By" field="modified_By" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto">{{dataItem.modified_By}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.modified_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.modified_On | date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Actions" [filterable]="false" [width]="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span>
                  <i class="fa fa-pencil eip-link" style="font-size: 1.25em; cursor: pointer;" (click)="addEditElementLink(dataItem,false)" aria-hidden="true" matTooltip="Edit"></i>
              </span>
          </ng-template>
      </kendo-grid-column>
  </kendo-grid>
</div>
<app-static-element-link *ngIf="isStaticElement"></app-static-element-link>